module.exports = __webpack_public_path__ + "img/osaka.a95c6987.png";